import React, { useCallback,  useState } from "react";
import { useDropzone } from "react-dropzone";
import _ from "lodash";
import { arrayGlueWith } from "../../utils/helper";
import { FileTypes } from "../../utils/appConstants";
import CloudUploadIcon from "../../assets/images/cloud-upload-icon.png";
import Image from "./Image";

interface iError {
  type: "invalid-file-type" | "max-file-upload-size";
  message: string;
}

interface iDropZone {
  onSuccess: (file: any) => void;
  onError?: (data: iError) => void;
  allowFileTypes?: string[];
  allowFileSize?: number;
  displayFileName?: boolean;
  content?: React.ReactNode;
  clearSingleFileDropZone?: boolean;
  disabled?: boolean;
}

const SingleFileDropZone = (props: iDropZone) => {
  // const [uploadedFileName, setUploadedFileName] = useState(null);
  const [fileTypeError, setFileTypeError] = useState("");
//  useEffect(() => {
//     if (props.clearSingleFileDropZone) {
//       setUploadedFileName(null);
//       setFileTypeError("");
//     }
//   }, [props.clearSingleFileDropZone,fileTypeError]);

  // const onDrop = useCallback((acceptedFiles:File[]) => {
  //   acceptedFiles.forEach((file: any) => {
  //     const { onSuccess, onError, allowFileTypes, allowFileSize } = props;

  //     // Reset error
  //     setFileTypeError("");
  //     const fileType = file.type || "";
  //     const fileName = file.name || "";
  //     const fileSize = file.size || 0;

  //     setUploadedFileName(fileName);

  //     // Check file types
  //     const fileMimeTypes = _.cloneDeep(allowFileTypes || [])
  //       .map((f: string) => FileTypes[f])
  //       .filter((f) => f);
  //     const fileTypes = arrayGlueWith(allowFileTypes || []);
  //     if (
  //       (fileMimeTypes || []).length > 0 &&
  //       !(fileMimeTypes || []).includes(fileType)
  //     ) {
  //       const message: string = `Only ${fileTypes} file types allowed`;
  //       if (typeof onError === "function") {
  //         onError({ type: "invalid-file-type", message });
  //       }
  //       setFileTypeError(message);
  //       return false;
  //     }

  //     // Check file size
  //     if (fileSize > (allowFileSize || 0)) {
  //       const mb = Math.floor((allowFileSize || 0) / 1024 / 1024);
  //       const message: string = `Max ${mb} mb file size allowed`;
  //       if (typeof onError === "function") {
  //         onError({ type: "max-file-upload-size", message });
  //       }
  //       setFileTypeError(message);
  //     }

  //     // Success
  //     if (typeof onSuccess === "function") {
  //       onSuccess(file);
  //     }
  //   });

  //   // eslint-disable-next-line
  // }, []);


  const onDrop = useCallback((acceptedFiles: File[]) => {
  acceptedFiles.forEach((file: any) => {
    const { onSuccess, onError, allowFileTypes, allowFileSize } = props;

    // Reset all state first
    // setUploadedFileName(null);
    setFileTypeError("");

    const fileType = file.type || "";
    const fileName = file.name || "";
    const fileSize = file.size || 0;
    const fileExt = fileName.split(".").pop()?.toLowerCase() || "";

    // Check file types
    const fileMimeTypes = _.cloneDeep(allowFileTypes || [])
      .map((f: string) => FileTypes[f])
      .filter(Boolean);
    const allowedExts = (allowFileTypes || []).map((f: string) => f.toLowerCase());
    const matchesMime =
      fileMimeTypes.length === 0 || fileMimeTypes.includes(fileType);
    const matchesExt =
      allowedExts.length === 0 || allowedExts.includes(fileExt);

    const fileTypes = arrayGlueWith(allowFileTypes || []);
    if (fileMimeTypes.length > 0 && !matchesMime && !matchesExt) {
      const message = `Only ${fileTypes} file types allowed`;
      if (typeof onError === "function") {
        onError({ type: "invalid-file-type", message });
      }
      setFileTypeError(message);
      // setUploadedFileName(null); // Ensure filename is cleared
      return;
    }

    // Check file size
    if (fileSize > (allowFileSize || 0)) {
      const mb = Math.floor((allowFileSize || 0) / 1024 / 1024);
      const message = `Max ${mb} mb file size allowed`;
      if (typeof onError === "function") {
        onError({ type: "max-file-upload-size", message });
      }
      setFileTypeError(message);
      // setUploadedFileName(null); // Ensure filename is cleared
      return;
    }

    // Success
    // setUploadedFileName(fileName);
    if (typeof onSuccess === "function") {
      onSuccess(file);
    }
  });

  // eslint-disable-next-line
}, []);

  const accept = React.useMemo(() => {
    const types = props.allowFileTypes || [];
    return types.reduce<Record<string, string[]>>((acc, ext) => {
      const mime = FileTypes[ext.toLowerCase()];
      if (mime) {
        acc[mime] = [`.${ext.toLowerCase()}`];
      }
      return acc;
    }, {});
  }, [props.allowFileTypes]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: Object.keys(accept).length > 0 ? accept : undefined,
    disabled: !!props.disabled,
    noClick: !!props.disabled,
    noDrag: !!props.disabled,
  });

  return (
    <div
      {...getRootProps()}
      style={props.disabled ? { opacity: 0.6, pointerEvents: "none" } : undefined}
    >
      <input {...getInputProps()} disabled={!!props.disabled} />
      <div className="drop-area">
        {props?.content ? (
          props?.content
        ) : (
          <>
            <p>Drag or browse an image here to upload</p>
            <p className="small">Browse image from your computer</p>
            {/* <CloudUploadIcon /> */}
            <Image src={CloudUploadIcon} alt="Cloud Upload Icon" />
          </>
        )}
      </div>
      {/* {props.displayFileName === true && uploadedFileName && (
        <aside>
          <p>{uploadedFileName}</p>
        </aside>
      )} */}
      {!_.isEmpty(fileTypeError) && (
        <span className="error-msg" style={{ color: 'red', textAlign: 'center', display: 'block' }}>{fileTypeError}</span>
      )}
    </div>
  );
};

SingleFileDropZone.defaultProps = {
  allowFileTypes: [],
  displayFileName: true,
  allowFileSize: 2097152, // 2 mb
};

export default SingleFileDropZone;
